import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=3cdba956&scoped=true"
import script from "./LoadingCard.vue?vue&type=script&lang=ts"
export * from "./LoadingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdba956",
  null
  
)

export default component.exports